
<template>
  <!--开门日志-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="openLogId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :deleteParam="deleteParam"
      :rowSelection="false"
      @resetSearch = "resetSearch"
    >
      <template slot="opt_isSuccess" slot-scope="{row}">
        <span>{{row.isSuccess === 1 ? '成功' : '失败'}}</span>
      </template>
      <template slot="opt_t" slot-scope="{row}">
        <span>{{row.mobile}}</span>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../utils/mixins';
import { empty } from 'ant-design-vue-admin-x';
export default {
  mixins: [fetchSelect],
  name: 'openLog',
  data () {
    return {
      searchList: [
        { props: ['communityId'], placeholder: '小区名称', options: [], inputType: 'select', fetchOptions: this.getOptions},
        { props: ['mobile'], placeholder: '手机号', options: [], inputType: 'input' },
        { props: ['openType'], placeholder: '开门方式', options: [], inputType: 'select' },
        { props: ['isSuccess'], placeholder: '开门状态', options: this.$store.state.isSuccessList, inputType: 'select' },
        { props: ['createDate'], placeholder: ['开门时间', '开门时间'], options: [], inputType: 'dateTimePick' },
        {
          props: ['areaId'],
          placeholder: '省市',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(5, 'searchList', '1,2,3', e);
          }
        },
        { props: ['propertyId'], placeholder: '物业', options: [], inputType: 'select' },
        { props: ['memberType'], placeholder: '开门人身份', options: [], inputType: 'select' },
        { props: ['deviceCode'], placeholder: '设备编码', options: [], inputType: 'input' },
        { props: ['visitorPhone'], placeholder: '访客手机号', options: [], inputType: 'input' }
      ],
      tableOptList: [],
      rowOptList: [
        { text: '查看', handle: (row) => this.showPicture(row.photo), permi: ['community:openlog:show'] }
      ],
      columns: [
        { title: '开门时间', dataIndex: 'openTime', align: 'left', width: '' },
        { title: '所在小区', dataIndex: 'communityName', align: 'left', width: '' },
        { title: '通行门', dataIndex: 'positionName', align: 'left', width: '' },
        { title: '设备名称', dataIndex: 'deviceName', align: 'left', width: '' },
        { title: '身份', dataIndex: 'memberTypeDesc', align: 'left', width: '' },
        { title: '账号', dataIndex: 'mobile', align: 'left', width: '', scopedSlots: {customRender: 't'} },
        { title: '卡号', dataIndex: 'cardno', align: 'left', width: '' },
        { title: '开门方式', dataIndex: 'openTypeDesc', align: 'left', width: '' },
        { title: '状态', dataIndex: 'isSuccess', align: 'left', width: '', scopedSlots: {customRender: 'isSuccess'} },
        { title: '抓拍', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        communityId: undefined,
        mobile: undefined,
        openType: undefined,
        isSuccess: undefined,
        createDate: undefined,
        areaId: undefined,
        propertyId: undefined,
        memberType: undefined,
        deviceCode: undefined,
        visitorPhone: undefined
      },
      listApi: {
        url: '/openLog/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {}
    };
  },
  created () {
    this.getSelect();
    if (this.$route.query.id) {
      this.searchParams.deviceCode = this.$route.query.id;
      this.$nextTick(() => {
        this.$refs.table.$refs.search.changeFold();
        empty.$emit('setSearchValue', {
          deviceCode: this.searchParams.deviceCode
        });
      });
    }
  },
  methods: {
    resetSearch () {
      this.communitySelectByStep(undefined, undefined, 'searchList', '0');
      this.searchList[0].searchValue = undefined;
    },
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', '0');
    },
    getSelect () {
      let paramArr = [
        {index: 2, scope: 'searchList', query: 'comu_device_open_type'},
        {index: 7, scope: 'searchList', query: 'comu_device_open_member_type'}
      ];
      this.dictionarySelect(paramArr);
      this.regionSelect(5);
      // this.communitySelect(0, 'searchList', 1);
      this.communitySelectByStep(1, undefined, 'searchList', '0');
      this.propertySelect(6);
    },
    showPic (url) {
      this.waterMark({
        url: url,
        txt: '浩邈社区',
        xNum: 8,
        xDistance: 70,
        xAdd: 2,
        yNum: 12,
        yDistance: 50
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
